module.exports = __webpack_public_path__ + "static/media/klášter-vánoce2000-5.600176e0.jpg";